import React from "react";
import MasterData from "view/settings/masterdata/MasterData";
const InvoiceData = () => {
   
    const sections = [
        { label: "Status", value: "Status", items: [] },
    ];
   

    return (
        <>
            <MasterData pageTitle="Invoice" sections={sections} />
        </>

    );
};

export default InvoiceData;